import { render, staticRenderFns } from "./DesignTablePlatformRow.vue?vue&type=template&id=4c5fa539&scoped=true&"
import script from "./DesignTablePlatformRow.vue?vue&type=script&lang=js&"
export * from "./DesignTablePlatformRow.vue?vue&type=script&lang=js&"
import style0 from "./DesignTablePlatformRow.vue?vue&type=style&index=0&id=4c5fa539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5fa539",
  null
  
)

export default component.exports